import ApiService from '@/core/services/api.service';

export const WarrantyServiceService = {
  getAll(params = {}) {
    return ApiService.query(`v1/warranty/services`, { params });
  },

  getById(id) {
    return ApiService.get(`v1/warranty/services/${id}`);
  },

  create(data) {
    return ApiService.post('v1/warranty/services', data);
  },

  update(id, data) {
    return ApiService.put(`v1/warranty/services/${id}`, data);
  },

  delete(id) {
    return ApiService.delete(`v1/warranty/services/${id}`);
  },

  updateActiveStatus(id, isActive) {
    return ApiService.patch(`v1/warranty/services/${id}/active-status`, {
      isActive,
    });
  },
};

